import { reauthenticate, SessionExpiredError } from "@/shared/api";
import { useAppConfig } from "../../api";
import { ConnectionStatusView } from "./ConnectionStatus.view";

/**
 * Proves the full stack end to end: brand renders, the API answers, and the
 * caller has been identified.
 *
 * This is M0's acceptance criterion made visible.
 */
export function ConnectionStatus() {
  const { data, isPending, error, refetch } = useAppConfig();

  return (
    <ConnectionStatusView
      config={data}
      isLoading={isPending}
      error={error}
      isSessionExpired={error instanceof SessionExpiredError}
      onRetry={() => void refetch()}
      onReauthenticate={reauthenticate}
    />
  );
}
